import { useCallback } from 'react';
import { SMLRoutes } from '../../../../routing/sml/SMLRoutes';
import { useSMLRouter } from '../../../../routing/sml/hooks';
import { MeiliIndex } from '../SearchField/types';
import { PaletteEntry } from './usePaletteEntries';

/**
 * Opens the page of a palette row and closes the palette. "See all" opens the Search page with the
 * text (`/app/browse?q=`).
 */
export function usePaletteNavigate(query: string, onClose: () => void): (entry: PaletteEntry) => void {
  const router = useSMLRouter();
  return useCallback(
    (entry: PaletteEntry) => {
      if (entry.kind === 'seeAll') {
        router.push(SMLRoutes.browse, { q: query.trim() });
      } else if (entry.kind === 'page') {
        router.push(entry.match.page.route, entry.match.page.params);
      } else {
        const { item } = entry.result;
        if (item.type === MeiliIndex.artists) {
          router.push(SMLRoutes.artistDetails, { artistId: item.item.id });
        } else if (item.type === MeiliIndex.tracks) {
          router.push(SMLRoutes.trackDetails, { trackId: item.item.id });
        } else {
          router.push(SMLRoutes.playlistDetails, { playlistId: item.item.id });
        }
      }
      onClose();
    },
    [onClose, query, router]
  );
}
